<template>
  <div style="padding-top: 10px"></div>
  <div style="margin-top: 5px">
    <dialog class="myd" id="license">
      <div>Please enter Gumroad License Key</div>
      <div>
        <input type="text"  placeholder="License Key" v-model="gumroadLicense" />
      </div>
      <button id="closeBtn">Close</button> &nbsp;
      <button id="checkBtn">Check</button>
    </dialog>
  </div>
  <div class='divx wrapper desktop_view'>
      <section>
        <button class="invisible"><i class="fa fa-file-code-o" style="font-size: 30px;color: black" aria-hidden="true"></i> {{leftpanel[0]}}</button>
        <button class="invisible"><i class="fa fa-question-circle" style="font-size: 30px;color: black"  aria-hidden="true"></i> {{leftpanel[3]}}</button>
        <button class="invisible"><i class="fa fa-user-secret" style="font-size: 30px;color: salmon" aria-hidden="true"></i> {{leftpanel[2]}}</button>
        <button class="invisible"><img src="../assets/Stripe_icon_-_square.svg" alt="Stripe icon" width="30px" height="30px" /> {{leftpanel[1]}}</button>
      </section>
      <section>
        <div class='button'>
          <div class="steps">
            {{ rightpanel[1] }} [{{price_unit}} {{rightpanel[2]}}]<br>
            {{ rightpanel[3] }}<br>
            {{ rightpanel[4] }}<br>
            {{ rightpanel[5] }}<br>
            {{ rightpanel[9] }}<br>
            {{ rightpanel[7] }}<br>
            <button class="treidbtn" @click="showLicenseMessage">
              <img src="../assets/gumroad-logo-png_seeklogo-431430.png" width="40px" height="40px" alt="gumroad"/>
              {{rightpanel[11]}}
            </button>
            <br>
            <button v-if="!start_pay" class="treidbtn" @click="startPayment">
              <img src="../assets/Stripe_icon_-_square.svg" alt="Stripe icon" width="40px" height="40px" />
              {{rightpanel[8]}}
            </button>
            <div v-else class="loader"></div>
          </div>
        </div>
      </section>
    </div>
  <p class="mobile_view">
    <span class="pcard">
      <span class="pcard_container">{{leftpanel[0]}}</span>
    </span>
  </p>
  <p class="mobile_view">
    <span class="pcard">
      <span class="pcard_container">{{leftpanel[1]}}</span>
    </span>
  </p>
  <p class="mobile_view">
    <span class="pcard">
      <span class="pcard_container">{{leftpanel[2]}}</span>
    </span>
  </p>
  <p class="mobile_view">
    <span class="pcard">
      <span class="pcard_container">{{leftpanel[3]}}</span>
    </span>
  </p>
  <div class="vcard_alignment mobile_view">
    <div class="vcard left_vcard_position" >
      <div class="vcard_container">
        <div class="vcard_title">Steps</div>
        <div class="vcard_msg">{{ rightpanel[1] }} [{{price_unit}} {{rightpanel[2]}}]</div>
        <div class="vcard_msg">{{ rightpanel[3] }}</div>
        <div class="vcard_msg" >{{ rightpanel[4] }}</div>
        <div class="vcard_msg">{{ rightpanel[5] }}</div>
        <div class="vcard_msg">{{ rightpanel[9] }}</div>
        <div class="vcard_msg">{{ rightpanel[7] }}</div>
      </div>
      <button v-if="!start_pay" class="treidbtn mobile_view" @click="startPayment">
        <img src="../assets/Stripe_icon_-_square.svg" alt="Stripe icon" width="40px" height="40px" />
        {{rightpanel[8]}}
      </button>
      <div v-else class="loader mobile_view"></div>
      <br>
      <button class="treidbtn mobile_view"  @click="showLicenseMessage">
        <img src="../assets/gumroad-logo-png_seeklogo-431430.png" width="40px" height="40px" alt="gumroad"/>
        {{rightpanel[11]}}
      </button>
    </div>
  </div>
  <br>
  <div>
    <router-link to="/privacy">Privacy</router-link>
    <i class="fa fa-circle" aria-hidden="true" style="font-size: 8px;margin: 15px 15px"></i>
    <router-link to="/terms">Terms</router-link>
    <i class="fa fa-circle" aria-hidden="true" style="font-size: 8px;margin: 15px 15px"></i>
    <router-link to="/faq">FAQ</router-link>
    <i class="fa fa-circle" aria-hidden="true" style="font-size: 8px;margin: 15px 15px"></i>
    <!--<a target="_blank" href="http://www.ulip.ee/support">24/7</a>-->
    <a href="mailto:?to=dnan66@gmail.com&subject=Request Support [ UPAYS ] &body=Hello!">24/7</a>
  </div>
</template>
<script>
import {getBaseURL} from "../../url_endpoints"
import {getLeftPanelMessages, getRightPanelMessages} from "@/translate"
import {get_CLIENT_TEST, get_UPAYS_auth, get_CLIENT_LIVE, generateHID} from "@/components/hid";
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data () {
    return {
      start_pay: false,
      price_unit:29,
      lang:0,
      gumroadLicense:'',
      leftpanel:['[SHA256]encrypted cloud microservice','easy integrate your STRIPE account','no programming skills requested','payment with STRIPE','Non-consumable credits'],
      rightpanel:['How to use','1. Get Access Key : 30daysTrial or pay the fee','credits',
        '2. Configure the Payment Page',
        '3. Generate the PAYLink that displays the page',
        '4. Customize PAYLink with a pay unit and your app\'s Stripe Api key',
        '5. Attach the PAYLink at Your App "Pay" button',
        '7. Check Your Stripe account for sales','Lets start',
        '6. Test Payment Page that is connected now to your Stripe Account',
      ]
    }
  },
  created() {
    //console.log('HelloWord component created')
    this.emitter.off('payment')
    this.emitter.on('change_language', (evt) => {
      //console.log(evt.eventContent)
      if(evt.eventContent === '1') {
        this.leftpanel = getLeftPanelMessages(1)
        this.rightpanel = getRightPanelMessages(1)
        this.lang = 1
      }else {
        this.leftpanel = getLeftPanelMessages(0)
        this.rightpanel = getRightPanelMessages(0)
        this.lang = 0
      }
    })
  },
  mounted() {
    window.scroll(0, 0)
    localStorage.removeItem('akey')
    localStorage.removeItem('tkey')
    const language = localStorage.getItem('lang')
    this.lang = !language ? 0 : Number.parseInt(language)
    this.leftpanel = getLeftPanelMessages(this.lang)
    this.rightpanel = getRightPanelMessages(this.lang)
  },
  methods: {
    showInfo(){
      let msg = this.leftpanel[0].split('#')
      alert(msg[0].toUpperCase() + '\n'+msg[1].toUpperCase())
    },
    startPayment () {
      //console.log('Starting payment')
      this.emitter.on('payment', (evt) => {
        //console.log(evt.eventContent)
        if(evt.eventContent === 'ok') {
          //console.log("register the new client")
          this.emitter.emit('paypage', {'eventContent': '0'})
          this.registerClient()
        }
      })
      this.start_pay = true
      const upays_akey = 'c4a6babfbcdb6810baba1f1258454cc83bff1b34d70bdcd0ddeafb518ea02e71'
      /* keep it in the TEST MODE on local*/
      //const  API = get_CLIENT_TEST()
      //console.log(get_CLIENT_TEST())
      const  API = process.env.NODE_ENV === 'development' ? get_CLIENT_TEST() : get_CLIENT_LIVE()
      this.$router.push('/payment/'+this.lang+'/'+upays_akey+'/'+this.price_unit+'/'+API)
    },
    registerClient(){
      /*  register new client [paying] to the DB */
      const baseURL = getBaseURL()
      const auth = get_UPAYS_auth()
      /* generate a string for website name */
      const gname  = generateHID(Date.now().toString())
      const weblink = 'www.'+gname.substring(3,15) +'.com'
      //console.log(weblink)
      let rstatus = '500'
      fetch(baseURL+"/clients/register/clients", {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Authorization': `Basic ${auth}`,
          'Content-Type': 'application/json'
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify({weblink:weblink,c_keys:true})
      }).then(response => {
        if(response.status === 401){
          rstatus = '401'
        }
        return response.json()
      }).then( rsp => {
        if(rsp['auth']) {
          if(rsp["akey"]) {
            /* set sign in ok */
            localStorage.setItem('akey',rsp["akey"])
            this.emitter.emit('login_process', {'eventContent': 'ok'})
            this.$router.push('/configurator')
          }else {
            this.$router.push('/501')
          }
        }else {
          if(rstatus === '401'){
              this.$router.push('/401')
          }
          if(rsp['message'].includes('Duplicate')) {
            this.$router.push('/402')
          }
          if(rsp['message'].includes('DB')) {
            this.$router.push('/404')
          }
        }
      }).catch( () => {
        //console.log('Error when POST resource: ', err.message)
        //throw new Error('Register failed!\n'+err.message)
        //console.log(err.message)
        this.$router.push('/500')
      })
    },
    checkGumroadLicence(license_key){
      const gumroadURL = 'https://api.gumroad.com/v2/licenses/verify'
      const product_id ='Vt0Xv3Ru32AvVTGQlzZtGA==' // 'Vt0Xv3Ru32AvVTGQlzZtGA=='
      //const license_key = '28A0992F-EBA84A97-9E647056-EB5D72EC' // '28A0992F-EBA84A97-9E647056-EB5D72EC'
      fetch(gumroadURL, {
        method: 'POST' ,
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({product_id:product_id,license_key:license_key})
      }).then(response => {
        if(response) {
          if(response.status === 404 ){
            alert(`Licence key is invalid`)
          }else {
            console.log(response)
            alert(`Licence key validated!`)
            this.registerClient()
          }
        }else {
          console.log('Error request to check Gumroad Licence')
          alert('Your Gumroad Licence Key is invalid. Please try again.')
        }
      }).catch(error => {
        console.log(error)
        alert('Your Gumroad Licence Key cannot be checked')
      })
    },
    showLicenseMessage() {
      /* define modal that get License Key */
      const dialog = document.getElementById('license')
      const closeButtonDialog = document.getElementById('closeBtn')
      const checkButtonDialog = document.getElementById('checkBtn')
      // show dialog
      dialog.showModal()
      // "Close" button closes the dialog
      closeButtonDialog.addEventListener("click", () => {
        dialog.close()
      })
      checkButtonDialog.addEventListener("click", () => {
        dialog.close()
        this.checkGumroadLicence(this.gumroadLicense)
      })
    },
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../assets/x_card.css";

.invisible {
  margin-bottom: 10%;
  color: midnightblue;
  background-color: transparent;
  border: none;
  font-size: 15px;
  width: 23%;
}
.invisible:hover {
  font-size: 18px;
  cursor: crosshair;
}
.divx {
  transform:
      perspective(200px)
      rotateY(-5deg);
  transition: transform 1s ease 0s;
  border-radius: 4px;
  box-shadow:
      rgba(0, 0, 0, 0.024) 0px 0px 0px 1px,
      rgba(0, 0, 0, 0.05) 0px 1px 0px 0px,
      rgba(0, 0, 0, 0.03) 0px 0px 8px 0px,
      rgba(0, 0, 0, 0.1) 0px 20px 30px 0px;

  &:hover {
    transform: perspective(1000px) rotateY(-5deg);
  }
}
.wrapper {
  height: 78vh;
  display: flex;
}

.wrapper section {
  flex: 1;
  display: flex;
}

.wrapper section .button {
  margin-left: 25%;
  margin-top: 5%;
  padding: 5px 5px;
  background: transparent;
}
.wrapper section:first-child {
 /* background: url(https://picsum.photos/id/1036/800/800) center/cover;*/
  background: url("../assets/1048-800x800.jpg") center/cover;

}
.wrapper section:last-child {
  margin-left: -10vw;
  clip-path: polygon(10vw 0, 100% 0, 100% 100%, 0 100%);
  /*background: url(https://picsum.photos/id/1048/800/800) center/cover;*/
  background: url("../assets/img_(142).jpg") center/cover;

}
span{
  font-size: 18px;
  font-family: "Apple Braille", sans-serif;
}
.steps {
  font-size: 20px;
  color: snow;
  font-family: "Apple Symbols",system-ui;

}
.treidbtn {
  font-size: 40px;
  padding: 10px 10px;
  border-radius: 8px;
  transform:
      perspective(600px)
      rotateX(60deg)
      scale(0.7);
  box-shadow: 0px 20px 100px #555;
  transition:0.5s ease all;

  &:hover {
    cursor: pointer;
    transform:
        rotate(0deg)
        scale(1)
        translateY(10px);
  }
}
.loader {
  margin: 0px auto;
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #fa755a;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 2s linear infinite;
}

/* for Terms ...*/
a {
  color: black;
  font-size: 17px;
  opacity: 0.5;
}
a:hover{
   opacity: 1;
 }
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.mobile_view {
  display: none;
}
/* dialog that show generated key customer */
.myd {
  background: black;
  border-radius: 20px;
  margin-top: 200px;
  opacity: 0.8;
  color: white;
  border-color: #fa755a;
  font-family: Dialog,serif;
}
.myd:hover {
  opacity: 1;
}
.myd button {
  background-color: lightgrey;
  padding: 10px 30px;
  border-radius: 10px;
  cursor: pointer;
  margin-top: 30px;
}
.myd button:hover {
  background-color: white;
}
.myd div {
  margin-top: 10px;
}
.myd input {
  width: 280px;
  padding: 10px;
}
@media screen and (max-width: 600px){
  .invisible {
    visibility: hidden;
  }
  .wrapper {
    max-width: 100vw;
    max-height: 100vh;
    -o-object-fit: contain;
    object-fit: contain;
  }
  .wrapper section:first-child {
    width: 10%;
  }
  .wrapper section:last-child {
    width: 10%;
  }
  .wrapper section .button {
    margin: auto;
    font-size:15px;
    padding: 5px 10px;
  }
  .steps {
    padding: 20px 20px;
    font-size: 6px;
  }
  .treidbtn {
    font-size: 30px;
  }
  .desktop_view {
    display: none;
  }
  .mobile_view {
    display: inline-grid;
  }
}
</style>
